module.exports = __webpack_public_path__ + "img/business-2717063_640.f64e904e.jpg";